import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import _01_45auth_45global from "/app/middleware/01.auth.global.ts";
import _02_45user_45global from "/app/middleware/02.user.global.ts";
import _03_45i18n_45global from "/app/middleware/03.i18n.global.ts";
export const globalMiddleware = [
  validate,
  _01_45auth_45global,
  _02_45user_45global,
  _03_45i18n_45global
]
export const namedMiddleware = {
  "redirect-profile-necessary-item-edit-page": () => import("/app/middleware/redirectProfileNecessaryItemEditPage.ts"),
  "sentry-context": () => import("/app/middleware/sentryContext.ts")
}